/**
 * Money / date formatting shared by the billing pages. Same conventions the
 * instance payment history already uses: "119.00 EUR" and a medium-style
 * locale date.
 */

/** Cents -> "119.00 EUR"; null-safe ("—"). */
export function formatMoney(cents: number | null | undefined, currency: string | null | undefined): string {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) return "—";
  return `${(cents / 100).toFixed(2)} ${currency ?? "EUR"}`;
}

/** A calendar date in the user's locale (medium style), or "—". */
export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return "—";
  const date = new Date(d);
  return Number.isNaN(date.getTime())
    ? String(d)
    : date.toLocaleDateString(undefined, { dateStyle: "medium" });
}

/** "1 Jul 2026 – 1 Aug 2026", or "—" when neither end is known. */
export function formatPeriod(start: string | null, end: string | null): string {
  if (!start && !end) return "—";
  return `${formatDate(start)} – ${formatDate(end)}`;
}
